import React from "react";
import {TableLink} from "peggirkit";
import {FormattedMessage} from "react-intl";
import ViewFormatter from "@widgets/employees/overview/table/columns/ViewFormatter";
import {editFeaturedProduct} from "@/routing/Router";
import {FeaturedProductDetails} from "@/data/entities/product";
import {SetStateFn} from "@/utils/SetStateUtils";
import {DeleteFeaturedProductState} from "@widgets/featuredProducts/delete/DeleteFeaturedProductModal";

type Props = {
    deleteFeaturedProductState: SetStateFn<DeleteFeaturedProductState>,
    featuredProduct: FeaturedProductDetails,
};

const OptionsFormatter = ({featuredProduct, deleteFeaturedProductState}: Props) => {
    return (
        <div className={"flex flex-row flex-nowrap items-center justify-end gap-6"}>
            <TableLink
                color={"danger"}
                buttonAction={{
                    as: "button",
                    actionProps: {
                        onClick: e => {
                            e.preventDefault();
                            deleteFeaturedProductState({
                                showModal: true,
                                featuredProductId: featuredProduct.id,
                            });
                        },
                    }
                }}
            >
                <FormattedMessage id={"delete"}/>
            </TableLink>

            <ViewFormatter
                disabled={featuredProduct.product === null}
                to={
                    featuredProduct.product === null
                        ? "#"
                        : editFeaturedProduct(featuredProduct.id).absolutePath()
                }
            />
        </div>
    );
};

export default OptionsFormatter;